export function b_click(){
    var audio = new Audio("click_button_short_sharp_73510.mp3");
    audio.play();
}

export function fanfare() {
    var audio = new Audio("cartoon_success_fanfair.mp3");
    audio.play();
}
